<template>
  <div>
    <div class="time-section">
      <div class="sec-search">
        <div class="sea-left"></div>
        <div class="sea-right"></div>
      </div>
      <div class="calendar-cont">
        <div class="calendar-header">
          <div class="ehader-left">
            <span>{{ this.year }}年{{ this.month }}月</span>
          </div>
          <div class="ehader-right">
            <div class="select-month">
              <div class="prew-month">
                <el-button style="border: 0" @click="prevMonth">上个月</el-button>
              </div>
              <div class="today" @click="selToday">
                <el-button style="border: 0">今天</el-button>
              </div>
              <div class="current-month">
                <el-button style="border: 0" @click="nextMonth">下个月</el-button>
              </div>
              <div class="current-month">
                <el-button type="primary" @click="updateParkHoliday">保存</el-button>
              </div>
            </div>
          </div>
        </div>
        <div class="calendar-body">
          <div class="calendar-table">
            <table>
              <thead>
                <th>一</th>
                <th>二</th>
                <th>三</th>
                <th>四</th>
                <th>五</th>
                <th>六</th>
                <th>天</th>
              </thead>
              <tbody>
                <tr v-for="(val, inx) in datas" :key="inx">
                  <td
                    v-for="(item, index) in val"
                    :key="index"
                    :class="[
                      item.isMonth,
                      { 'is-today': item.isToday },
                      { 'is-selected': selectTimeStep == item.timeStamp },
                    ]"
                    @click="clickDay(item)"
                    @contextmenu.prevent="contextMenuDay(item, $event)"
                  >
                    <div>
                      <span>{{ item.day }}</span>
                      <span class="xiu">{{ item.isXiu ? '休' : '' }}</span>
                      <!-- :class='[{"xiu":item.isXiu},{"work":item.isWork}]' -->
                    </div>
                  </td>
                </tr>
              </tbody>
            </table>
          </div>
        </div>
      </div>
    </div>
    <div class="dialog-set" ref="dialogSet" v-show="showDom">
      <ul>
        <li @click="setHoliday" v-if="!selectDay.isXiu">
          <span>设置为休息日</span>
        </li>
        <li @click="setWorkday" v-else>
          <span>设置为工作日</span>
        </li>
        <!-- <li>
                    <span>取消所有设置</span>
                </li> -->
        <!-- <li @click="showDom = false">
                    <span>取消</span>
                </li> -->
      </ul>
    </div>
  </div>
</template>
<script>
let data = [
  {
    year: '2022',
    month1: [],
    month2: [],
    month3: [],
    month4: [],
    month5: [],
    month6: [],
    month7: [],
    month8: [],
    month9: [],
    month10: [],
    month11: [],
    month5012: [],
  },
];
import { getParkHoliday, updateParkHoliday } from '@/api/v4ward/carv2/carparkspace';
export default {
  props: {
    parkSpace: {
      type: Object,
      default() {
        return {};
      },
    },
  },
  data() {
    return {
      year: null, //当前正在查阅年份（翻到2022年那就是2022）
      month: null, //当前正在查阅月份
      day: null, //当前正在查阅天
      today: null, //今日日期
      thatYearData: {},
      isToday: [], //今天日期 拆分为数组
      selectTimeStep: null, //选中日期时间戳
      selectDay: {}, //正在处理得日期对象
      showDom: false, //右击显示弹窗内容
    };
  },
  created() {
    const date = new Date();
    this.isToday[0] = this.year = date.getFullYear();
    this.isToday[1] = this.month = date.getMonth() + 1;
    this.isToday[2] = this.day = date.getDate();
    this.today = `${this.year}-${this.month}-${this.day}`;
    this.selectTimeStep = new Date(
      `${this.isToday[0]}/${this.isToday[1]}/${this.isToday[2]}`
    ).getTime();
    this.getParkHoliday();
  },
  mounted() {
    document.onclick = () => {
      this.showDom = false;
    };
  },
  methods: {
    // 编辑节假日信息
    updateParkHoliday() {
      updateParkHoliday(data).then((res) => {
        this.$message({
          message: '操作成功！',
          type: 'success',
        });
      });
    },
    // 获取节假日信息
    getParkHoliday() {
      let year = this.dayjs().format('YYYY');
      getParkHoliday({ spaceId: this.parkSpace.id, year: year }).then((res) => {
        data = res.data;
        this.initDate();
      });
    },
    // 设置休息日
    setHoliday() {
      if (this.selectDay.year == this.year) {
        if (this.month != this.selectDay.month) {
          this.$message({
            message: '请设置当月的节假日！',
            type: 'warning',
          });
          return;
        }
        data['month' + Number(this.selectDay.month)].push(this.selectDay.timeStamp);
        this.initDate();
      } else {
        this.$message({
          message: '请设置当年的节假日！',
          type: 'warning',
        });
      }
    },
    // 设置工作日
    setWorkday() {
      if (this.selectDay.year == this.year) {
        if (this.month != this.selectDay.month) {
          this.$message({
            message: '请设置当月的工作日！',
            type: 'warning',
          });
          return;
        }
        data['month' + Number(this.selectDay.month)].splice(
          data['month' + Number(this.selectDay.month)].indexOf(this.selectDay.timeStamp),
          1
        );
        this.initDate();
      } else {
        this.$message({
          message: '请设置当年的工作日！',
          type: 'warning',
        });
      }
    },
    //初始化日历数据
    initDate() {
      let lastMonth = [];
      let calendarMonth = [];
      let isWeek =
        new Date(this.year, this.month - 1, 1).getDay() == 0
          ? 6
          : new Date(this.year, this.month - 1, 1).getDay() - 1; //当月开始是周几
      let isMonthDay = new Date(this.year, this.month, 0).getDate(); //当月多少天
      let isPrevMonthDay = new Date(this.year, this.month - 1, 0).getDate() + 1; //上个月是多少天
      if (this.year != this.thatYearData.year) {
        data.forEach((ele) => {
          if (ele.year == this.year) {
            this.thatYearData = ele;
          }
        });
      }
      console.log(123456);
      // 计算上月展示的天数
      for (let i = 1; i < isMonthDay + 1; i++) {
        let timeStamp = this.dayjs(`${this.year}/${this.month}/${i}`).format('YYYY-MM-DD');
        let month = Number(this.dayjs(`${this.year}/${this.month}/${i}`).format('MM'));
        let year = Number(this.dayjs(`${this.year}/${this.month}/${i}`).format('YYYY'));
        let thatYearData = this.getInitThatYearData(year);
        // 判断是否是休息日
        let isXiu = false;

        if (year == thatYearData.year) {
          if (thatYearData['month' + month].indexOf(timeStamp) > -1) {
            isXiu = true;
          }
        }
        calendarMonth.push({
          day: i,
          timeStamp: timeStamp,
          month: month,
          year: year,
          isWork: false,
          isXiu: isXiu,
          isMonth: '',
          isToday:
            this.isToday[0] == this.year && this.isToday[1] == this.month && this.isToday[2] == i,
          time: `${this.year}-${this.month}-${i}`,
        });
      }
      // 计算当月展示的天数
      for (let k = isPrevMonthDay - isWeek; k < isPrevMonthDay; k++) {
        let timeStamp = this.dayjs(
          `${this.month == 12 ? this.year - 1 : this.year}/${this.month - 1}/${k}`
        ).format('YYYY-MM-DD');
        let month = Number(
          this.dayjs(
            `${this.month == 12 ? this.year - 1 : this.year}/${this.month - 1}/${k}`
          ).format('MM')
        );
        let year = Number(
          this.dayjs(
            `${this.month == 12 ? this.year - 1 : this.year}/${this.month - 1}/${k}`
          ).format('YYYY')
        );
        // 判断是否是休息日
        let isXiu = false;
        if (year == this.thatYearData.year) {
          if (this.thatYearData['month' + month].indexOf(timeStamp) > -1) {
            isXiu = true;
          }
        }
        lastMonth.push({
          day: k,
          timeStamp: new Date(
            `${this.month == 12 ? this.year - 1 : this.year}/${this.month - 1}/${k}`
          ).getTime(),
          month: this.dayjs(
            `${this.month == 12 ? this.year - 1 : this.year}/${this.month - 1}/${k}`
          ).format('MM'),
          year: this.dayjs(
            `${this.month == 12 ? this.year - 1 : this.year}/${this.month - 1}/${k}`
          ).format('YYYY'),
          isWork: true,
          isXiu: isXiu,
          isMonth: 'prev',
          isToday: false,
          time: `${this.month == 12 ? this.year - 1 : this.year}-${this.month - 1}-${k}`,
        });
      }
      // 计算下一个月展示的天数
      for (let y = 1; y < 43 - (isMonthDay + isWeek); y++) {
        let timeStamp = this.dayjs(
          `${this.month == 12 ? this.year + 1 : this.year}/${this.month + 1}/${y}`
        ).format('YYYY-MM-DD');
        let month = Number(
          this.dayjs(
            `${this.month == 12 ? this.year + 1 : this.year}/${this.month + 1}/${y}`
          ).format('MM')
        );
        let year = Number(
          this.dayjs(
            `${this.month == 12 ? this.year + 1 : this.year}/${this.month + 1}/${y}`
          ).format('YYYY')
        );
        let thatYearData = this.getInitThatYearData(year);
        // 判断是否是休息日
        let isXiu = false;
        if (thatYearData['month' + month].indexOf(timeStamp) > -1) {
          isXiu = true;
        }
        calendarMonth.push({
          day: y,
          timeStamp: new Date(
            `${this.month == 12 ? this.year + 1 : this.year}/${this.month + 1}/${y}`
          ).getTime(),
          month: this.dayjs(
            `${this.month == 12 ? this.year + 1 : this.year}/${this.month + 1}/${y}`
          ).format('MM'),
          year: this.dayjs(
            `${this.month == 12 ? this.year + 1 : this.year}/${this.month + 1}/${y}`
          ).format('YYYY'),
          isWork: false,
          isXiu: isXiu,
          isMonth: 'current',
          isToday: false,
          time: `${this.month == 12 ? this.year + 1 : this.year}-${this.month + 1}-${y}`,
        });
      }
      calendarMonth = [...lastMonth, ...calendarMonth];
      this.datas = this.spArr(calendarMonth, 7);
    },
    // 获得初始化当年的节假日数据
    getInitThatYearData(year) {
      let thatYearData = {
        year: year,
        month1: [],
        month2: [],
        month3: [],
        month4: [],
        month5: [],
        month6: [],
        month7: [],
        month8: [],
        month9: [],
        month10: [],
        month11: [],
        month5012: [],
      };
      data.forEach((ele) => {
        if (ele.year == year) {
          thatYearData = ele;
        }
      });
      return thatYearData;
    },
    //格式化数据
    spArr(arr, num) {
      if (num < 1) {
        return newArr;
      }
      let newArr = [];
      for (let i = 0; i < arr.length; ) {
        newArr.push(arr.slice(i, (i += num)));
      }
      return newArr;
    },
    //上个月
    prevMonth() {
      if (this.month < 2) {
        this.month = 12;
        this.year -= 1;
      } else {
        this.month -= 1;
      }
      // 判断后台接口返回的数据有没有当年的数据
      let isHave = false;
      data.forEach((ele) => {
        if (ele.year == this.year) {
          isHave = true;
        }
      });
      if (!isHave) {
        data.unshift(this.getInitThatYearData(this.year));
      }
      this.initDate();
    },
    //下个月
    nextMonth() {
      if (this.month > 11) {
        this.month = 1;
        this.year += 1;
      } else {
        this.month += 1;
      }
      // 判断后台接口返回的数据有没有当年的数据
      let isHave = false;
      data.forEach((ele) => {
        if (ele.year == this.year) {
          isHave = true;
        }
      });
      if (!isHave) {
        data.push(this.getInitThatYearData(this.year));
      }
      this.initDate();
    },
    //回到今天
    selToday() {
      this.year = this.isToday[0];
      this.month = this.isToday[1];
      this.day = this.isToday[2];
      this.initDate();
    },
    //点击某一天
    clickDay(item) {
      // if(item.isMonth == 'prev'){
      // this.prevMonth()
      // }else if(item.isMonth == 'current'){
      // this.nextMonth()
      // }
      this.selectTimeStep = item.timeStamp;
    },
    //右击某一天
    contextMenuDay(item, event) {
      this.selectDay = item;
      this.selectTimeStep = item.timeStamp;
      this.showDom = true;
      this.$refs.dialogSet.style.left = event.x + 'px';
      this.$refs.dialogSet.style.top = event.y + 'px';
    },
  },
};
</script>
<style lang="scss" scoped>
.time-section {
  padding: 10px;
  .sec-search {
    display: flex;
  }
  .sea-left {
    flex: 1;
    display: flex;
  }
  .sea-right {
    display: flex;
  }
  .calendar-cont {
    border: 1px solid rgb(235, 238, 245);
    padding: 5px 10px;
    margin-top: 10px;
    .calendar-header {
      display: flex;
      padding-bottom: 5px;
      .ehader-left {
        flex: 1;
        display: flex;
        align-items: center;
        span {
          color: #000;
        }
      }
      .ehader-right {
        .select-month {
          display: flex;
          > div {
            border: 1px solid rgb(235, 238, 245);
            cursor: pointer;
          }
          :nth-child(2) {
            border-left: 0;
            border-right: 0;
          }
        }
      }
    }
    .calendar-body {
      border: 1px solid rgb(235, 238, 245);
      .calendar-table {
        table {
          width: 100%;
          th {
            padding: 10px 0;
            color: rgb(96, 98, 102);
          }
          tr {
            .is-selected {
              background-color: rgb(242, 248, 254);
              color: rgb(64, 158, 255);
            }
            .is-today {
              color: rgb(64, 158, 255);
            }
            .prev {
              color: rgb(192, 196, 204);
            }
            .current {
              color: rgb(192, 196, 204);
            }
            td {
              vertical-align: top;
              border-top: 1px solid rgb(235, 238, 245);
              border-right: 1px solid rgb(235, 238, 245);
              transition: background-color 0.2s ease 0s;

              div {
                height: 50px;
                padding: 8px;
                display: flex;
                span {
                  display: inline-block;
                  min-width: 20px;
                }
                span:first-child {
                  flex: 1;
                }
                .xiu {
                  display: inline-block;
                  width: 20px;
                  color: #198fff;
                }

                .work {
                  color: red;
                }
              }
              &:hover {
                cursor: pointer;
                background-color: rgb(242, 248, 254);
              }
            }
          }
        }
      }
    }
  }
}
.dialog-set {
  position: fixed;
  left: 50%;
  top: 50%;
  ul {
    border-radius: 8px;
    border: 1px solid rgb(228, 231, 237);
    overflow: hidden;
    li {
      padding: 10px 15px;
      cursor: pointer;
      background: #fff;
      &:hover {
        background: rgb(245, 247, 250);
      }
      span {
        color: rgb(96, 98, 102);
      }
    }
  }
}
</style>
